import { type FC } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@packages/shared/src/ui/Button/Button';
import { useAbTesting } from '@packages/shared/src/abtesting/useAbTesting/useAbTesting';

import { filterSettingsFab } from '../../activeFeatureFlags';
import { getTestId } from '../../utils/featureFlags/getTestId';

export type FilterSettingsFabButtonProps = {
  visible: boolean;
  onClick?: () => void;
};

export const FilterSettingsFabButton: FC<FilterSettingsFabButtonProps> = ({ visible, onClick }) => {
  const { formatMessage } = useIntl();
  const { setOutcome } = useAbTesting();

  const onClickHandler = () => {
    onClick?.();

    // remove if A/B test is finished
    setOutcome(getTestId(filterSettingsFab), {
      COF: 1,
    });
  };

  return (
    <div
      aria-hidden={!visible}
      inert={!visible}
      className={`z-app-bar fixed right-0 bottom-2 left-0 flex items-center justify-center transition-opacity duration-300 [body:has(.nl-bottom-sheet)_&]:bottom-[5rem] ${visible ? 'opacity-100' : 'pointer-events-none opacity-0'}`}
    >
      <Button color="primary" size="medium" onClick={onClickHandler}>
        <span className="icon-emp-filter" />
        {formatMessage({
          id: 'filters.selection.mobile.filterFabButton.text',
          defaultMessage: 'Filtern & Sortieren',
        })}
      </Button>
    </div>
  );
};
